import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import FamilyPlazaTopSection from '../../../../components/family-plaza/FamilyPlazaTopSection';
import FamilyPlazaSubHeading from '../../../../components/family-plaza/FamilyPlazaSubHeading';
import PaymentInquiry from '../../../../services/FamilyPlaza/PaymentInquiry';

const ManagementFeePaymentInquiryMobile = () => {
    const navigate = useNavigate();

    // State for search functionality
    const [searchType, setSearchType] = useState('고인명');
    const [searchValue, setSearchValue] = useState('');
    const [sealNumber, setSealNumber] = useState('');
    const [byeolbitgwanSearchValue, setByeolbitgwanSearchValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // State for search results
    const [deceasedResults, setDeceasedResults] = useState([]);
    const [contractorResults, setContractorResults] = useState([]);
    const [showResults, setShowResults] = useState(false);

    // Results states
    const [searchResults, setSearchResults] = useState(null);
    const [showBasicResults, setShowBasicResults] = useState(false);

    const [byeolbitgwanResults, setByeolbitgwanResults] = useState(null);
    const [showByeolbitgwanResults, setShowByeolbitgwanResults] = useState(false);

    // Handle search type change
    const handleSearchTypeChange = (type) => {
        setSearchType(type);
        setSearchValue('');
        setShowResults(false);
        setDeceasedResults([]);
        setContractorResults([]);
    };

    // Handle main search input change
    const handleSearchInputChange = (e) => {
        setSearchValue(e.target.value);
        if (e.target.value.trim() === '') {
            setShowResults(false);
            setDeceasedResults([]);
            setContractorResults([]);
        }
    };

    // Handle seal number input change
    const handleSealNumberChange = (e) => {
        setSealNumber(e.target.value);
    };

    // Handle byeolbitgwan search input change
    const handleByeolbitgwanSearchChange = (e) => {
        setByeolbitgwanSearchValue(e.target.value);
    };

    // Handle existing contractor search (integrated from original component)
    const handleExistingContractorSearchClick = async () => {
        if (!searchValue.trim()) {
            setError('검색어를 입력해주세요.');
            return;
        }

        setLoading(true);
        setError(null);

        try {

            // Use the PaymentInquiry service for unified search
            const searchParams = {
                deceasedName: searchType === '고인명' ? searchValue : '',
                contractorName: searchType === '계약자명' ? searchValue : ''
            };

            const response = await PaymentInquiry.getManagementFeeSearch(searchParams);

            if (response && response.length > 0) {

                // Set results based on search type
                if (searchType === '고인명') {
                    setDeceasedResults(response);
                } else {
                    setContractorResults(response);
                }
                setShowResults(true);
            } else {
                setError('검색 결과가 없습니다.');
                setShowResults(false);
            }
        } catch (err) {
            console.error('Mobile1: API Error:', err);
            setError('검색 중 오류가 발생했습니다.');
            setShowResults(false);
        } finally {
            setLoading(false);
        }
    };




    // ===== Navigate to Detailed Results =====
    const handleDetailedSearch = () => {
        if (!searchResults) {
            alert('조회 정보를 입력해주세요.');
            return;
        }

    const goinId = searchResults.fullResult?.goinId;
    const customerName = searchResults.fullResult?.customerName;
    navigate('/management-fee-inquiry-results', {
            state: { goinId, customerName }
    });
    };

    // ===== Byeolbitgwan Mode2 Search =====
    const handleByeolbitgwanSearchClick = async () => {
        if (!sealNumber.trim()) {
            alert('조회 정보를 입력해주세요.');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            // Mode2 API call
            const response = await PaymentInquiry.getMode2FeeSearch({
                deceasedName: byeolbitgwanSearchValue,
                enshrineName: sealNumber
            });

            if (response && response.length > 0) {
                const basicInfo = response[0];
                const paymentHistory = response.slice(1);

                const apiData = {
                    id: basicInfo.id || '',
                    deceasedName: basicInfo.deceasedName || '',
                    contractorName: basicInfo.customerName || '',
                    enshrineUnit: basicInfo.enshrineName || '',
                    firstEnshrineDate: basicInfo.enshrineDay || '',
                    birthday: basicInfo.birthday || '',
                    address: basicInfo.address || '',
                    phoneHome: basicInfo.phoneHome || '',
                    phoneCell: basicInfo.phoneCell || '',
                    paymentHistory: paymentHistory.map(item => ({
                        startEndDay: item.startEndDay || '',
                        receiptPrice: item.receiptPrice || '',
                        paymentStatus: item.paymentStatus || '',
                        receiptDay: item.receiptDay || '',
                        enshrineName: item.enshrineName || ''
                    }))
                };

                setByeolbitgwanResults(apiData);
                setShowByeolbitgwanResults(true);

                localStorage.setItem('managementFeeSearchResults', JSON.stringify(apiData));

                setSearchResults(null);
                setShowBasicResults(false);
            } else {
                alert('조회 결과가 없습니다.');
                setByeolbitgwanResults(null);
                setShowByeolbitgwanResults(false);
            }
        } catch (err) {
            console.error(err);
            alert('조회 중 오류가 발생했습니다.');
        } finally {
            setLoading(false);
        }
    };




    // Handle deceased name inquiry
    const handleDeceasedInquiry = (goinId, goinName) => {
        navigate('/management-fee-inquiry-results', {
            state: {
                goinId: goinId,
                customerName: goinName
            }
        });
    };

    // Handle contractor inquiry
    const handleContractorInquiry = (goinId, customerName, birthday) => {
        navigate('/management-fee-inquiry-results', {
            state: {
                goinId: goinId,
                customerName: customerName,
                birthday: birthday
            }
        });
    };

    return (
        <div className="management-fee-payment-inquiry-mobile1 announcement-list-page cyber-info-page-pc">

            <FamilyPlazaTopSection />

            <main className="main-content">

                <FamilyPlazaSubHeading heading="관리비 납부 조회" />
                <div>

                    <div>
                        <h3 className="management-inquiry-mobile-form-title">기존 계약자 조회</h3>
                    </div>
                    {/* Search Type Selection */}
                    <div className="search-type-section">
                        <button
                            className={`search-type-btn ${searchType === '고인명' ? 'active' : ''}`}
                            onClick={() => handleSearchTypeChange('고인명')}
                        >
                            고인명
                        </button>
                        <button
                            className={`search-type-btn ${searchType === '계약자명' ? 'active' : ''}`}
                            onClick={() => handleSearchTypeChange('계약자명')}
                        >
                            계약자명
                        </button>
                    </div>

                    {/* Main Search Section */}
                    <div className="main-search-section">
                        <div className="search-input-container">
                            <input
                                type="text"
                                placeholder="고인명 혹 계약자명 입력해 주세요."
                                className="search-input"
                                value={searchValue}
                                onChange={handleSearchInputChange}
                            />
                            <button
                                className="search-btn"
                                onClick={handleExistingContractorSearchClick}
                                disabled={loading}
                            >
                                {loading ? '검색중...' : <FaSearch />}
                            </button>
                        </div>
                    </div>

                    {/* Starlight Hall Exclusive Section */}
                    <div className="byeolbitgwan-section">
                        <div className="byeolbitgwan-title-container">
                            <h3 className="byeolbitgwan-title">별빛관 전용</h3>
                        </div>
                        <div className="byeolbitgwan-input-container">
                            <input
                                type="text"
                                placeholder="봉인번호를 입력해 주세요. 예) 별빛관-000"
                                className="byeolbitgwan-input"
                                value={sealNumber}
                                onChange={handleSealNumberChange}
                            />
                        </div>

                        <div className="byeolbitgwan-search-container">
                            <textarea
                                rows="4" cols="40"
                                type="text"
                                placeholder="고인명,계약자명, 계약자 주민등록번호 앞자리 중 1개를 입력해 주세요. 예) 홍길동 또는 77120"
                                className="byeolbitgwan-search-input"
                                value={byeolbitgwanSearchValue}
                                onChange={handleByeolbitgwanSearchChange}
                            />
                            <button
                                className="byeolbitgwan-search-btn"
                                onClick={handleByeolbitgwanSearchClick}
                                disabled={loading}
                            >
                                {loading ? '검색중...' : <FaSearch />}
                            </button>
                        </div>
                    </div>

                    {/* Error Message */}
                    {error && (
                        <div className="error-message">
                            {error}
                        </div>
                    )}

                    {/* Deceased Name Results Table */}
                    {showResults && searchType === '고인명' && deceasedResults.length > 0 && (
                        <div>
                            <div className="results-section">
                                <div className="results-table">
                                    <div className="table-header">
                                        <div className="table-cell">고인명</div>
                                        <div className="table-cell">안치일</div>
                                    </div>
                                    {deceasedResults.map((result, index) => (
                                        <div key={index} className="table-row">
                                            <div className="table-cell">{result.goinName}</div>
                                            <div className="table-cell">{result.enshrineDay}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="results-section">
                                <div className="results-table">
                                    <div className="table-header">
                                        <div className="table-cell">계약자</div>
                                        <div className="table-cell">조회하기</div>
                                    </div>
                                    {deceasedResults.map((result, index) => (
                                        <div key={index} className="table-row">
                                            <div className="table-cell">{result.customerName}</div>
                                            <div className="table-cell">
                                                <button
                                                    className="inquiry-btn"
                                                    onClick={() => handleContractorInquiry(result.goinId, result.customerName, result.customerBirthday)}
                                                >
                                                    <FaSearch />
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Contractor Results Table */}
                    {showResults && searchType === '계약자명' && contractorResults.length > 0 && (
                        <div className="results-section">
                            <div className="results-table">
                                <div className="table-header">
                                    <div className="table-cell">고인명</div>
                                    <div className="table-cell">조회하기</div>
                                </div>
                                {contractorResults.map((result, index) => (
                                    <div key={index} className="table-row">
                                        <div className="table-cell">{result.goinName}</div>
                                        <div className="table-cell">
                                            <button
                                                className="inquiry-btn"
                                                onClick={() => handleContractorInquiry(result.goinId, result.customerName, result.customerBirthday)}
                                            >
                                                <FaSearch />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}


                    {/* Results: Byeolbitgwan Mode2 */}
                    {/* {showByeolbitgwanResults && byeolbitgwanResults && (
                        <div className="results-section">
                            <div className="results-table">
                                <div className="table-header">
                                    <div className="table-cell">고인명</div>
                                    <div className="table-cell">안치일</div>
                                    <div className="table-cell">계약자</div>
                                    <div className="table-cell">조회하기</div>
                                </div>
                                <div className="table-row">
                                    <div className="table-cell">{byeolbitgwanResults.deceasedName}</div>
                                    <div className="table-cell">{byeolbitgwanResults.firstEnshrineDate} 안치</div>
                                    <div className="table-cell">{byeolbitgwanResults.contractorName} 계약</div>
                                    <div className="table-cell">
                                        <button
                                            className="inquiry-btn"
                                            onClick={() =>
                                                navigate('/management-fee-inquiry-results', {
                                                    state: {
                                                        deceasedName: byeolbitgwanResults.deceasedName,
                                                        enshrineName: byeolbitgwanResults.enshrineUnit,
                                                        contractorName: byeolbitgwanResults.contractorName
                                                    }
                                                })
                                            }
                                            disabled={loading}
                                        >
                                            <FaSearch />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )} */}

                    {/* Byeolbitgwan Results - Table 1 */}
                    {showByeolbitgwanResults && byeolbitgwanResults && (
                        <div>
                            <div className="results-section">
                                <div className="results-table">
                                    <div className="table-header">
                                        <div className="table-cell">고인명</div>
                                        <div className="table-cell">안치일</div>
                                    </div>
                                    <div className="table-row">
                                        <div className="table-cell">{byeolbitgwanResults.deceasedName}</div>
                                        <div className="table-cell">{byeolbitgwanResults.firstEnshrineDate} 안치</div>
                                    </div>
                                </div>
                            </div>

                            {/* Byeolbitgwan Results - Table 2 */}
                            <div className="results-section">
                                <div className="results-table">
                                    <div className="table-header">
                                        <div className="table-cell">계약자</div>
                                        <div className="table-cell">조회하기</div>
                                    </div>
                                    <div className="table-row">
                                        <div className="table-cell">{byeolbitgwanResults.contractorName} 계약</div>
                                        <div className="table-cell">
                                            <button
                                                className="inquiry-btn"
                                                onClick={() =>
                                                    navigate('/management-fee-inquiry-results', {
                                                        state: {
                                                            deceasedName: byeolbitgwanResults.deceasedName,
                                                            enshrineName: byeolbitgwanResults.enshrineUnit,
                                                            birthdayMode2: byeolbitgwanResults.birthday,
                                                            goinIdMode2: byeolbitgwanResults.id,
                                                            customerNameMode2: byeolbitgwanResults.contractorName,
                                                          }
                                                    })
                                                }
                                                disabled={loading}
                                            >
                                                <FaSearch />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}


                    {/* No Results Message */}
                    {showResults && ((searchType === '고인명' && deceasedResults.length === 0) ||
                        (searchType === '계약자명' && contractorResults.length === 0)) && (
                            <div className="no-results-message">
                                검색 결과가 없습니다.
                            </div>
                        )}
                </div>

                {/* Results Table (Mode1 + Mode2 unified) */}
                {/* {showResults && deceasedResults.length > 0 && (
                    <div className="results-section">
                        <div className="results-table">
                            <div className="table-header">
                                <div className="table-cell">고인명</div>
                                <div className="table-cell">계약자</div>
                                <div className="table-cell">조회</div>
                            </div>
                            {deceasedResults.map((item, index) => (
                                <div key={index} className="table-row">
                                    <div className="table-cell">{item.goinName}</div>
                                    <div className="table-cell">{item.customerName}</div>
                                    <div className="table-cell">
                                        <button onClick={() => handleContractorInquiry(item.goinId, item.customerName)}><FaSearch /></button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )} */}
            </main>
        </div>
    );
};

export default ManagementFeePaymentInquiryMobile;